import { paramDate, paramFormat } from "../constants/parameterNames";
import { getParamValue } from "../helpers/parameter.accessors";

const formatDateError = 'Unable to format date.';

const requiredParameters = [
    {
        name: paramDate,
        description: 'The date value to apply the format to',
    }
];

const optionalParameters = [
    {
        name: paramFormat,
        description: 'The standard or custom format for the date. Default is d (short date pattern). Standard date formats: https://docs.microsoft.com/en-us/dotnet/standard/base-types/standard-date-and-time-format-strings. Custom date formats: https://docs.microsoft.com/en-us/dotnet/standard/base-types/custom-date-and-time-format-strings.',
    }
];

const description = 'Formats a date into a specified format. Standard date formats: https://docs.microsoft.com/en-us/dotnet/standard/base-types/standard-date-and-time-format-strings. Custom date formats:  https://docs.microsoft.com/en-us/dotnet/standard/base-types/custom-date-and-time-format-strings.';

const getSettings = (parameters) => ({
    dateValueToFormat: getParamValue(parameters, paramDate),
    format: getParamValue(parameters, paramFormat, 'd'),
});

const executeAsync = async ({ api, parameters }) => {
    const settings = getSettings(parameters);

    const data = await api.formatDate(settings);

    if (!data) {
        throw new Error(formatDateError);
    }

    if (!data.Success) {
        throw new Error(data.Error || formatDateError);
    }

    return data.Data;
};

const FormatDate = {
    description,
    executeAsync,
    optionalParameters,
    requiredParameters,
};

export default FormatDate;